import { render } from "./CharteredLists.vue?vue&type=template&id=ef6a7ec2&scoped=true"
import script from "./CharteredLists.vue?vue&type=script&lang=js"
export * from "./CharteredLists.vue?vue&type=script&lang=js"

import "./CharteredLists.vue?vue&type=style&index=0&id=ef6a7ec2&scoped=true&lang=scss"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6a7ec2"]])

export default __exports__